import React, { FunctionComponent, forwardRef, useState } from 'react';
import styled from 'styled-components';
import DOMPurify from 'dompurify';
import { useAuthToken, useAsyncEffect } from '../../../../hooks';
import { onboardingapi } from '../../../../api';

export const Outerdiv = styled.div`
  .terms-and-conditions.page {
  }
  .page-title {
    width: 100%;
    display: flex;
    text-align: center;
    flex-direction: column;
    padding: 1rem;
    box-sizing: border-box;
  }
  .main-section-list {
    padding-left: 1rem;

    > li::marker {
      font-weight: bold;
      text-decoration: underline;
    }
  }
  .main-section-list-item {
    margin-bottom: 0.5rem;
  }
  .main-section-list-item:first-child {
    margin-top: 0.5rem;
  }
  .address-section {
    margin: 1rem;
    display: flex;
    flex-direction: column;
  }
  .page-container {
    display: flex;
    padding-bottom: 1rem;

    > div {
      flex: 1 1 0;

      &:first-child {
        padding-right: 0.5rem;
      }
    }
  }
  .definition {
    padding-top: 4px;
  }
`;

export const TermsAndConditions: FunctionComponent<
  React.DetailedHTMLProps<React.HTMLAttributes<HTMLDivElement>, HTMLDivElement>
> = forwardRef((props, ref) => {
  const [TCContent, setTCContent] = useState('');
  const { authToken } = useAuthToken();

  useAsyncEffect(async () => {
    const res = await onboardingapi.get(authToken!, `/terms-and-conditions`);
    const clean = DOMPurify.sanitize(res);
    setTCContent(clean);
  }, []);

  return (
    <Outerdiv
      {...props}
      ref={ref}
      data-testid="terms-and-conditions-section"
      id="terms-and-conditions-section"
    >
      <div dangerouslySetInnerHTML={{ __html: TCContent }} />
    </Outerdiv>
  );
});
